import React, { useEffect, useRef, useState } from "react";
import * as echarts from "echarts";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { Card, Radio, Spin } from "antd";
import { useStoreUpdaterWithAPI } from "../../Hooks/UseStoreUpdaterWithApi";
import { getAdjustedDate } from "./CommonFunctions";
import { adjustTimeByFiveHoursThirtyMinutes } from "../../Utils/DateConverstion";
import { APIConstants } from "../../Common/APIConstants";



const GasSankey = ({activeTab}) => {
  const chartRef = useRef(null);
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [sankeyData, setSankeyData] = useState({ nodes: [], links: [] });
  const correctDate = new Date(getAdjustedDate());
  const[isLoading,setIsLoading]=useState(false)
  const defaultFromDate = dayjs()
    .subtract(1, "day")
    .hour(6)
    .minute(0)
    .second(0);
  const defaultToDate = dayjs().hour(6).minute(0).second(0);
  const [toDate, setToDate] = useState(defaultToDate);
  const [fromDate, setFromDate] = useState(defaultFromDate);
  const [inputType,setInputType]=useState(0)
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  const color = useSelector((state) => state.ThemeChange);
  // console.log(color);
  const colors = ["#59c3c9", "#696969", "#C8ff08", "#005E60"];
  const [selectedOption, setSelectedOption] = useState("1");

const handleRadioChange = (e) => {
  const selectedValue = e.target.value;
  setSelectedOption(selectedValue);
  // console.log(selectedValue)
  if(selectedValue==1){
    setInputType(0)
  }else{
    setInputType(1)
  }

  if (selectedValue == 1) {
    setFromDate(dayjs().subtract(1, "day").hour(6).minute(0).second(0));
    setToDate(dayjs().hour(6).minute(0).second(0));

  } else if (selectedValue == 2) {
    setFromDate(dayjs().startOf("month").hour(6).minute(0).second(0));
    setToDate(dayjs().hour(6).minute(0).second(0));
  }
};

  useEffect(() => {

    const colorList = ["#59c3c9", "#696969", "#C8ff08", "#005E60"]; // Ordered colors

    const fetchData = async () => {
      setIsLoading(true)
      const inputData = {
        FromDate: adjustTimeByFiveHoursThirtyMinutes(fromDate),
        ToDate: adjustTimeByFiveHoursThirtyMinutes(toDate),
      };
      console.log(inputType)

      const response = await makeRequest({
        type: APIConstants.GET,
        url: activeTab==="3"?`${APIConstants.DASHBOARD_SANKEY}/${inputData.FromDate}/${inputData.ToDate}/${inputType}`:`${APIConstants.DASHBOARD_SANKEY_GAS}/${inputData.FromDate}/${inputData.ToDate}/${inputType}`,
      });
      console.log(response);

      const nodesSet = new Set();
      const links = [];

      const targetColorMap = new Map();
      let colorIndex = 0;

      response?.forEach((item) => {
        const source = item.source || "Total";
        const target = item.target || "Total";
        const value = item.consumption;

        nodesSet.add(source);
        nodesSet.add(target);

        // Assign a color in order for each new target
        if (!targetColorMap.has(target)) {
          const color = colorList[colorIndex % colorList.length];
          targetColorMap.set(target, color);
          colorIndex++;
        }

        links.push({
          source,
          target,
          value,
          lineStyle: { color: targetColorMap.get(target) },
        });
      });

      const nodes = Array.from(nodesSet).map((name) => ({ name }));
      setSankeyData({ nodes, links });
      setIsLoading(false)
    };

    fetchData();
  }, [inputType]);

useEffect(() => {
    if (!chartRef.current) return;

    const chart = echarts.init(chartRef.current);

    const labelColor = isdarkMode ? "#fff" : "#000";

    // Detect first level and root total
    const rootName = sankeyData.nodes?.[0]?.name;
    const rootTotal = sankeyData.links
      .filter((l) => l.source === rootName)
      .reduce((sum, l) => sum + (l.value || 0), 0);

    // Detect leaf nodes (no outgoing edges)
    const sourceNodes = new Set(sankeyData.links.map((l) => l.source));
    const leafNodes = sankeyData.nodes
      .filter((node) => !sourceNodes.has(node.name))
      .map((node) => node.name);

    const allValuesZero = sankeyData.links.every(
      (l) => (l.value ?? 0) === 0
    );

    if (allValuesZero) {
      chart.setOption({
        graphic: {
          elements: [
            {
              type: "text",
              left: "center",
              top: "middle",
              style: {
                text: "No data available",
                fontSize: 20,
                fill: isdarkMode ? "#aaa" : "#555",
              },
            },
          ],
        },
      });
    } else {
     chart.setOption({
  tooltip: { trigger: "item", triggerOn: "mousemove" },

  toolbox: {
    show: true,
    right: 20,
    feature: {
      saveAsImage: {
        show: true,
        title: "Download Image",
        type: "png",          // png | jpeg | svg
        name: "Sankey_Chart", // file name
        backgroundColor: isdarkMode ? "#000" : "#fff",
        pixelRatio: 2         // higher = better quality
      }
    }
  },

  animationDuration: 800,
  series: [
    {
      type: "sankey",
      data: sankeyData.nodes,
      links: sankeyData.links,
      layout: "none",
      emphasis: { focus: "adjacency" },
      lineStyle: { curveness: 0.5 },
      label: {
        color: labelColor,
        formatter: (params) => {
          const name = params.name;
          const value = params.value || 0;

          if (!rootTotal) return `${name} ${value}`;

          if (leafNodes.includes(name)) {
            const percent = Math.min(
              100,
              ((value / rootTotal) * 100)
            ).toFixed(1);

            return `${name} ${value} (${percent}%)`;
          }

          return `${name} ${value}`;
        },
      },
    },
  ],
});

    }

    const resizeObserver = new ResizeObserver(() => chart.resize());
    resizeObserver.observe(chartRef.current);

    return () => {
      resizeObserver.disconnect();
      chart.dispose();
    };
  }, [sankeyData, isdarkMode]);


  console.log(sankeyData);

  return (
        <Card
      title={
        <div className={`${isdarkMode?'text-white':'text-black'}`}>
        {activeTab==="3"?" Nemak Aluminium – Energy Consumption Statistics":"Nemak Aluminium – Gas Consumption Statistics"}
          {/* Energy Consumption Statistics */}
        </div>
      }
      hoverable
      className="shadow-md rounded-xl border max-h-[75vh]"
      style={{
        background: isdarkMode ? "#1f2937" : "#ffffff",
        color: isdarkMode ? "white" : "black",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: "10px" }} >
        <Radio.Group  onChange={handleRadioChange} value={selectedOption}>
          <Radio className={`${isdarkMode?'text-white':'text-black'}`} value="1">Yesterday Consumption ({activeTab==="3"?"kWh":"Kg"})</Radio>
          <Radio  className={`${isdarkMode?'text-white':'text-black'}`} value="2">MTD Consumption ({activeTab==="3"?"kWh":"Kg"})</Radio>
        </Radio.Group>
      </div>
      
<div
  style={{
    position: "relative",
    width: "100%",
    height: "60vh",
    minHeight: "400px",
    maxHeight: "70vh"
  }}
>
  {isLoading && (
    <div
      style={{
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(255,255,255,0.6)",
        zIndex: 10
      }}
    >
      <Spin size="large" />
    </div>
  )}

  <div
    ref={chartRef}
    style={{
      width: "100%",
      height: "100%",
      overflow: "hidden"
    }}
  />
</div>
      {/* <div 
       ref={chartRef} 
       style={{
    width: "100%",
    height: "60vh",
    minHeight: "400px",
    maxHeight: "70vh",
    overflow: "hidden"
  }}></div> */}
    </Card>

  );
};



export default GasSankey;
